import { createFileRoute, redirect } from '@tanstack/react-router';
import { canManageCatalog } from '@/auth/roles';
import { InstituicoesCursosPage } from './-InstituicoesCursosPage';

export const Route = createFileRoute('/_auth/_shell/instituicoes-cursos/')({
  // EU-732 / CAT-001 — esconder o item do menu não basta, porque a rota é
  // alcançável digitando a URL. EU-749: o gate deixou de ser `admin` e passou a
  // aceitar também `customer-support`. A recusa definitiva segue sendo o 403 do
  // Core.
  beforeLoad: () => {
    if (!canManageCatalog()) throw redirect({ to: '/inicio' });
  },
  component: InstituicoesCursosPage,
});
